import { render, staticRenderFns } from "./NavigationDropdownMobile.vue?vue&type=template&id=32c67123&scoped=true&"
import script from "./NavigationDropdownMobile.vue?vue&type=script&lang=js&"
export * from "./NavigationDropdownMobile.vue?vue&type=script&lang=js&"
import style0 from "./NavigationDropdownMobile.vue?vue&type=style&index=0&id=32c67123&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c67123",
  null
  
)

export default component.exports